<!-- 日付選択不可の場合の表示用 -->
<template>
  <section class="row">
    <div class="title-block">乗車日</div>
    <p class="date">{{ displayMfittDetailDate(date) }}</p>
  </section>
</template>

<script>
export default {
  name: "MFITTBookingDisabledSelectDate",
  props: {
    date: {
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.row {
  margin: 20px 6px 8px;
  display: flex;
  align-items: center;
}

.title-block {
  font-size: 13px;
  font-weight: bold;
}

.date {
  font-size: 14px;
  font-weight: normal;
  margin-left: 10px;
}
</style>
